export const EventTypeConfig = [
    { label: "Shelling", value: "DAMAGE" },
    { label: "Fire Damage", value: "SHELLING" },
    { label: "Military Surveillance", value: "OBSERVATION" },
];
